import PickupCode from './PickupCode';

export default PickupCode;
